require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-responsive-web-design-projects-build-a-personal-portfolio-webpage.json") })
        }
      }, "path---responsive-web-design-responsive-web-design-projects-build-a-personal-portfolio-webpage");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-responsive-web-design-projects-build-a-personal-portfolio-webpage!./.cache/json/responsive-web-design-responsive-web-design-projects-build-a-personal-portfolio-webpage.json
// module id = 2706
// module chunks = 231608221292675